'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   * @Author: edvardchen
                                                                                                                                                                                                                                                                   * @Date:   2017-03-24 16:56:20
                                                                                                                                                                                                                                                                   * @Last Modified by: jerryfwang
                                                                                                                                                                                                                                                                   * @Last Modified time: 2021-02-02 10:20:38
                                                                                                                                                                                                                                                                   */

exports.circleShareUrl = circleShareUrl;
exports.userCenterUrl = userCenterUrl;
exports.postUrl = postUrl;

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function origin(env) {
  switch (env) {
    case 'gray':
      return 'https://gray.quan.qq.com';
    case 'test':
      return 'http://test.quan.qq.com';
    default:
      return 'https://quan.qq.com';
  }
}

/* eslint-disable import/prefer-default-export */
/**
 * 话题圈分享地址
 * @param  {String} options.id
 * @param  {String} options.from
 * @param  {String} options.ch
 * @param  {String} options.env
 * @param  {String} options.envParam
 * @return {String}
 */
function circleShareUrl(_ref) {
  var id = _ref.id,
      from = _ref.from,
      ch = _ref.ch,
      env = _ref.env,
      _ref$envParam = _ref.envParam,
      envParam = _ref$envParam === undefined ? '01' : _ref$envParam;

  var params = {
    circleid: id,
    from: from,
    ch: ch,
    env: envParam
  };

  return origin(env) + '/circle?' + _queryString2.default.stringify(params);
}

/* eslint-disable import/prefer-default-export */
/**
 * 个人主页地址 edit by sourcewang
 * @param  {String} options
 * @param  {String} options.userId | qehId
 * @param  {String|Number} options.accountType 企鹅号type为9, 其他根据社区账号类型
 * @param  {String=} options.defaulttab 默认tab，目前已知的1为动态 2为热文 3为视频 5为小视频
 * @param  {String=} options.qbVersion 一定qb内才传,qb版本(86两位数), 拿到qbUrl，不传的话也支持302跳转qb的地址
 * @param  {Number=} options.platform 平台,用于qb地址拿版本判断,0为默认未知(qb>=86)，1为Android (qb>=83 )2为IOS(qb>=87)
 * @param  {String=} options.from from和ch为产品统计用的外部渠道号
 * @param  {String=} options.ch
 * @param  {String=} options.env 环境 'gray' 'test'
 * @return {String}
 */
function userCenterUrl(_ref2) {
  var userId = _ref2.userId,
      accountType = _ref2.accountType,
      _ref2$defaulttab = _ref2.defaulttab,
      defaulttab = _ref2$defaulttab === undefined ? 1 : _ref2$defaulttab,
      ch = _ref2.ch,
      qbVersion = _ref2.qbVersion,
      _ref2$platform = _ref2.platform,
      platform = _ref2$platform === undefined ? 0 : _ref2$platform,
      env = _ref2.env,
      _ref2$ext = _ref2.ext,
      ext = _ref2$ext === undefined ? {} : _ref2$ext;

  var params = {
    defaulttab: defaulttab,
    ch: ch
  };
  var userKey = accountType + '_' + userId;
  var url = origin(env) + '/userCenter/' + userKey + '?' + _queryString2.default.stringify(params);

  if (platform === 1 && qbVersion >= 83 || qbVersion >= 87) {
    // 这里参数问题可以咨询royguo
    var paramsQB = {
      userid: userId,
      accounttype: accountType,
      channel: ch,
      url: url + '&env=03',
      defaulttab: defaulttab,
      sh_na_id: '1015',
      memo: '0',
      coverToolbar: 'true',
      return: '1',
      extinfo: encodeURIComponent(_queryString2.default.stringify(ext))
    };
    url = 'qb://ext/hp?module=circleUserCenter&component=circleUserCenter&' + _queryString2.default.stringify(paramsQB);
  }

  return url;
}
/* eslint-disable import/prefer-default-export */
/**
 * 帖子地址 edit by sourcewang
 */
function postUrl(_ref3) {
  var circleId = _ref3.circleId,
      postId = _ref3.postId,
      ch = _ref3.ch,
      qbVersion = _ref3.qbVersion,
      _ref3$platform = _ref3.platform,
      platform = _ref3$platform === undefined ? 0 : _ref3$platform,
      env = _ref3.env,
      _ref3$queryP = _ref3.queryP,
      queryP = _ref3$queryP === undefined ? {} : _ref3$queryP;

  var params = _extends({
    zch: ch
  }, queryP);
  var url = origin(env) + '/post/' + circleId + '/' + postId + '?' + _queryString2.default.stringify(params);

  if (qbVersion >= 80) {
    // 只对8.0以上版本直接qb地址，其他版本重定向
    var paramsQB = {
      url: url + '&env=' + (platform === 1 ? '01' : '02'),
      postid: postId,
      circleid: circleId,
      sh_na_id: 1015
    };
    url = 'qb://ext/circle?' + _queryString2.default.stringify(paramsQB);
  } else {
    url += '&redrt=native';
  }

  return url;
}